module.exports = "//cdn-staging.livechat-static.com/webapp/img/campaigns/intent-transaction-tooltip.png?153b62c061a765cbe0f54c9cbb78d0f3";